import { Component, computed, input } from '@angular/core';

// Pipes
import { SafeHtmlPipe } from "../../../shared/pipes/safe-html.pipe";

// NG Bootstrap
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

// Font Awesome
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MarkdownPipe } from 'ngx-markdown';
import { AsyncPipe } from '@angular/common';


@Component({
  selector: 'app-followup-history',
  templateUrl: './followup-history.component.html',
  imports: [SafeHtmlPipe, NgbTooltipModule, FontAwesomeModule, MarkdownPipe, AsyncPipe]
})
export class FollowupHistoryComponent {
  readonly followupHistory = input<{ question: string, answer: string, textWithCitations: string }[]>();
  readonly followUpLoading = input<boolean>(false);

  // readonly followupHistoryMarkdown = computed(() => {
  //   return this.followupHistory().map(followUp => {
  //     const citationsHtml = followUp.citations
  //       .map(citation => {
  //         const svgIcon = `<img src="/images/icons/fontawesome/link-solid-full.svg" alt="link" height="14" style="position: relative; bottom: 1px;" />`;

  //         const referenceBtn = citation.reference
  //           ? `<span class="btn btn-secondary rounded-pill p-0 px-2 mx-1 tas-anchor-icon-tooltip">
  //             <i>${svgIcon}</i>
  //             <span class="tas-anchor-icon-tooltip-text">
  //               ${citation.reference.replace(/\n/g, '<br />')}
  //             </span>
  //           </span>`
  //           : '';

  //         return citation.reference ? `${citation.section}${referenceBtn}` : `${citation.section}`;
  //       })
  //       .join('');

  //     return {
  //       ...followUp,
  //       citationsHtml // aggiungiamo la nuova proprietà con HTML delle citazioni
  //     };
  //   });
  // });
}
